export default __webpack_public_path__ + "static/media/ret_sta_3.23c3db07.jpeg";